// Front/src/utils/scaleTypeFormValidation.js

export const isPositiveNumber = (value) => {
    return value !== "" && !isNaN(value) && Number(value) >= 0;
};

export const validateScaleTypeData = (formData, t) => {
    if (!formData.catalogNumber?.trim()) {
        return t.scale_catalog_required;
    }
    if (!String(formData.weightUnits).trim()) {
        return t.scale_weight_units_required;
    }
    if (!String(formData.accuracyClass).trim()) {
        return t.scale_accuracy_required;
    }
    if (!String(formData.manufacturer).trim()) {
        return t.scale_manufacturer_required;
    }
    if (!String(formData.model).trim()) {
        return t.scale_model_required;
    }
    if (!isPositiveNumber(formData.maxValue)) {
        return t.scale_max_invalid;
    }
    if (!isPositiveNumber(formData.minValue)) {
        return t.scale_min_invalid;
    }
    if (!isPositiveNumber(formData.dValue)) {
        return t.scale_d_invalid;
    }
    if (!isPositiveNumber(formData.eValue)) {
        return t.scale_e_invalid;
    }
    if (!isPositiveNumber(formData.nValue)) {
        return t.scale_n_invalid;
    }

    const d = parseFloat(formData.dValue);
    const e = parseFloat(formData.eValue);
    if (!isNaN(d) && !isNaN(e) && e < d) {
        return t.eLowerThanD;
    }

    return null;
};
